<script setup lang="ts">
// hooks
import { useTrustpilotWidget } from '@hooks/widgets/trustpilot-widget.hook'

defineOptions({
  name: 'TrustpilotWidget',
})

withDefaults(defineProps<{
  view?: 'responsive' | 'short' | 'full'
}>(), {
  view: 'responsive',
})

const TRUSTPILOT_BUSINESSUNIT_ID = '62b56a39a4416e378b6292ab'
const TRUSTPILOT_TOKEN = '127b1e70-a6cc-4925-932e-cee17cf9b103'
const TEMPLATE_ID_MICRO_COMBO = '5419b6a8b0d04a076446a9ad'
const TEMPLATE_ID_MICRO_TRUSTSCORE = '5419b6ffb0d04a076446a9af'
const TRUSTPILOT_REVIEW_URL = 'https://www.trustpilot.com/review/brighterly.com'

const {
  refBoxFull,
  refBoxShort,
} = useTrustpilotWidget()
</script>

<template>
  <div
    class="trustpilot-widget-host"
    :class="`trustpilot-widget-host--${view}`"
  >
    <!-- Client-only: the Trustpilot bootstrap script auto-replaces `.trustpilot-widget`
         content with an iframe on load, which races Vue hydration and corrupts the
         SSR DOM (iframe vs the server-rendered <a>) → hydration mismatch that breaks
         the whole hero subtree. Not SSR-ing the widget removes the node Vue would
         otherwise try to hydrate. -->
    <ClientOnly>
      <div
        v-if="view !== 'short'"
        ref="refBoxFull"
        class="trustpilot-widget trustpilot-widget-host__box trustpilot-widget-host__box--full"
        data-locale="en-US"
        :data-template-id="TEMPLATE_ID_MICRO_COMBO"
        :data-businessunit-id="TRUSTPILOT_BUSINESSUNIT_ID"
        data-style-height="20px"
        data-style-width="100%"
      >
        <a
          :href="TRUSTPILOT_REVIEW_URL"
          target="_blank"
          rel="noopener"
        >Trustpilot</a>
      </div>
      <div
        v-if="view !== 'full'"
        ref="refBoxShort"
        class="trustpilot-widget trustpilot-widget-host__box trustpilot-widget-host__box--short"
        data-locale="en-US"
        :data-template-id="TEMPLATE_ID_MICRO_TRUSTSCORE"
        :data-businessunit-id="TRUSTPILOT_BUSINESSUNIT_ID"
        data-style-height="20px"
        data-style-width="100%"
        :data-token="TRUSTPILOT_TOKEN"
      >
        <a
          :href="TRUSTPILOT_REVIEW_URL"
          target="_blank"
          rel="noopener"
        >Trustpilot</a>
      </div>
    </ClientOnly>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/TrustpilotWidget.scss" />
